import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder,FormGroup, FormControl,Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import{UserService} from '../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';



declare var $:any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  registerFormGroup:FormGroup;
  username_error:string='';
  password_error:string='';
  group:Object={};
  showMe:boolean =false;
  token:any='';
  loader_image:boolean=false
  // emailPattern = "/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/"
  emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$";


  constructor(private _router: Router,private toastr: ToastrService,private route: ActivatedRoute,private _authService: AuthService,private userService:UserService,private formBuilder: FormBuilder) { 

   
  }

  ngOnInit() {

    this.group['fname']=new FormControl('',[Validators.required]);
    this.group['lname']=new FormControl('',[Validators.required]);
    this.group['email']=new FormControl('',[Validators.required,Validators.pattern(this.emailPattern)]);
    this.group['phone']=new FormControl('',[Validators.required]);
    this.group['country']=new FormControl('',[Validators.required]);
    this.group['company']=new FormControl('',[Validators.required]);
    this.group['designation']=new FormControl('',[Validators.required]);

		
		this.registerFormGroup =  this.formBuilder.group(this.group);
	
    
  }

  


  ngAfterViewInit(): void {
  
    $('.message a').click(function(e){
      e.preventDefault();
      
      $('form').animate({height: "toggle", opacity: "toggle"}, "slow");
   });

   $(document).ready(function(){ 
    $('input').blur(function(event) {
    var inputValue = this.value;
    if (inputValue) {
      this.classList.add('value-exists');
    } else {
      this.classList.remove('value-exists');
    }
    });
    });

  }

  register() {

    if(this.registerFormGroup.status =='VALID'){

      let time = Math.round(+new Date()/1000).toString();

      let data={
        fname:this.registerFormGroup.value['fname'],
        lname:this.registerFormGroup.value['lname'],
        email:this.registerFormGroup.value['email'],
        phone:this.registerFormGroup.value['phone'],
        country:this.registerFormGroup.value['country'],
        company:this.registerFormGroup.value['company'],
        designation:this.registerFormGroup.value['designation'],
        page:'register',
        xtoken:btoa(time),
        register:true

      }

      this.loader_image=true

      this.userService.getUserList(data).subscribe( (res)=>{

        this.loader_image=false

        if(res.status=='success'){

          this.toastr.success('Your registration request has been sent for approval. We will get back you shortly.', '', {timeOut: 3000});
          this._router.navigate(['/vlogin']);

        } else{
          this.toastr.error('Your registration request failed. Your account may already exists with same resgistration details.', '', {timeOut: 3000});

        }

      });

    }else{

      this.checkInput();
    }
    
  }

  checkInput(){ 
        
    if(this.registerFormGroup.controls['fname'].status=="INVALID"){

      this.toastr.error('First Name field required', '', {timeOut: 2000});

    }else  if(this.registerFormGroup.controls['lname'].status=="INVALID"){

      this.toastr.error('Last Name field required', '', {timeOut: 2000});

    }else if(this.registerFormGroup.controls['email'].status=="INVALID"){

      this.toastr.error('Please enter valid email address', '', {timeOut: 2000});

    }else if(this.registerFormGroup.controls['phone'].status=="INVALID"){

      this.toastr.error('Please enter valid phone number', '', {timeOut: 2000});

    }else  if(this.registerFormGroup.controls['country'].status=="INVALID"){

      this.toastr.error('Please select a country name', '', {timeOut: 2000});

    }else if(this.registerFormGroup.controls['company'].status=="INVALID"){

      this.toastr.error('Company Name field required', '', {timeOut: 2000});

    }else  if(this.registerFormGroup.controls['designation'].status=="INVALID"){

      this.toastr.error('Job Title field required', '', {timeOut: 2000});

    }

  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
 

}
